import { IBase, IStep } from "@app/common";

export interface StepFormValues extends Partial<IStep> { }

export const transformStepFormValuesToPayload = (values: Omit<Partial<IStep>, keyof IBase>): Partial<IStep> => {
  return {
    ...values,
    stepToProductVariations: values.stepToProductVariations?.map((stepToProductVariation, index) => ({
      ...stepToProductVariation,
      position: index
    }))
  }
}